__turbopack_context__.v({
  "filterHint": "GraftabilityIssueList-module-scss-module__sY8-cq__filterHint",
  "item": "GraftabilityIssueList-module-scss-module__sY8-cq__item",
  "itemHeader": "GraftabilityIssueList-module-scss-module__sY8-cq__itemHeader",
  "kindBadge": "GraftabilityIssueList-module-scss-module__sY8-cq__kindBadge",
  "list": "GraftabilityIssueList-module-scss-module__sY8-cq__list",
  "location": "GraftabilityIssueList-module-scss-module__sY8-cq__location",
  "moreIssues": "GraftabilityIssueList-module-scss-module__sY8-cq__moreIssues",
  "root": "GraftabilityIssueList-module-scss-module__sY8-cq__root",
  "summary": "GraftabilityIssueList-module-scss-module__sY8-cq__summary",
  "type": "GraftabilityIssueList-module-scss-module__sY8-cq__type",
  "typeCode": "GraftabilityIssueList-module-scss-module__sY8-cq__typeCode",
});
